<div class="application-main">
    <!-- header -->
    <section class="application-header">
        <div class="custom-toolbar">
            <clfl-header></clfl-header>
        </div>
    </section>
    <section class="application-body">
        <router-outlet></router-outlet>
    </section>

    <!-- footer -->
    <section class="application-footer">
        <div class="k-d-flex k-align-items-center k-justify-content-center">
            <div>
                <img width="50" height="50" class="k-mr-sm k-ml-sm" src="../assets/img/UE-logo.svg" />
                <img width="50" height="50" class="k-mr-sm" src="../assets/img/guvern-logo.svg" />
                <img width="50" height="50" class="k-mr-sm" src="../assets/img/structurale-logo.svg" />
            </div>
            <span style="margin: 0 auto">{{ footerText }}</span>
        </div>
    </section>
</div>
